import React from 'react';
import { Filter, X } from 'lucide-react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const CalculationFilters = ({ filters, setFilters }) => {
  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const clearFilters = () => {
    setFilters({
      dateFrom: '',
      dateTo: '',
      projectName: '',
      profitStatus: 'all'
    });
  };

  const hasActiveFilters = filters?.dateFrom || filters?.dateTo || filters?.projectName || filters?.profitStatus !== 'all';

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Filter className="h-5 w-5 text-muted-foreground" />
          <h3 className="font-semibold text-foreground">Filtros</h3>
        </div>
        {hasActiveFilters && (
          <Button
            onClick={clearFilters}
            variant="ghost"
            size="sm"
            className="text-muted-foreground hover:text-foreground"
          >
            <X className="h-4 w-4 mr-1" />
            Limpar Filtros
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="date"
          label="Data Início"
          value={filters?.dateFrom}
          onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
          placeholder="Selecione a data"
        />

        <Input
          type="date"
          label="Data Fim"
          value={filters?.dateTo}
          onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
          placeholder="Selecione a data"
        />

        <Input
          type="text"
          label="Nome do Projeto"
          value={filters?.projectName}
          onChange={(e) => handleFilterChange('projectName', e?.target?.value)}
          placeholder="Buscar por nome"
        />

        <Select
          label="Status de Lucro"
          value={filters?.profitStatus}
          onChange={(value) => handleFilterChange('profitStatus', value)}
          options={[
            { value: 'all', label: 'Todos' },
            { value: 'profit', label: 'Apenas Lucro' },
            { value: 'loss', label: 'Apenas Prejuízo' }
          ]}
        />
      </div>
    </div>
  );
};

export default CalculationFilters;